<div class="stable-height background">
  <div class="container d-flex flex-md-row flex-column">
    <div class="col text-background p-4 content-container">
      <div class="row mb-4 mb-sm-2 mt-4">
        <div class="col-12 d-inline-block d-flex flex-column choose-plan-title-wrapper">
          <h2 class="title">Over 70% of missing pets with premium accounts made it home safely</h2>
        </div>
      </div>
      <h5>
        <b>Leaving no stone unturned to find missing pets</b>
      </h5>
      <p>
        Our Lost & Found cover helps you find a missing pet fast and contact you the moment they're found.
      </p>
      <p>
        We've helped find & reunite pets who've travelled over 300 miles from home.
      </p>
      <span class="footer">
        *Based on missing pet reports submitted & closed Jan-Aug 2024
      </span>
    </div>
    <div class="image-container">
      <img
        src="/assets/images/home/carousel-slide-3.jpeg"
        alt="carousel slide 3"
        class="slide-image"
      />
    </div>
  </div>
</div>
